import { Checkbox } from 'antd';
import classNames from 'classnames';
import React from 'react';
import CustomTooltip from '../customTooltip';
import type { IProps } from './types';
import './style.scss';

export const CustomCheckbox = ({
  disabled = false,
  checked = false,
  defaultChecked = false,
  indeterminate = false,
  onChange: onChangeProp = () => {},
  label = '',
  id = '',
  tooltipTitle = '',
  className,
}: IProps): React.JSX.Element => {
  /**
   * Reports a checkbox toggle to the caller as a boolean. Reads e.target.checked from the change event and forwards it to the optional onChange prop.
   *
   * @param e - The checkbox change event.
   * @returns Nothing.
   */
  const onChange = (e: any) => {
    onChangeProp?.(e.target.checked);
  };

  return (
    <CustomTooltip title={tooltipTitle} placement="bottom">
      <Checkbox
        id={id}
        className={classNames('custom-checkbox-container', className)}
        checked={checked}
        indeterminate={indeterminate}
        disabled={disabled}
        defaultChecked={defaultChecked}
        onChange={onChange}
      >
        {label}
      </Checkbox>
    </CustomTooltip>
  );
};

export default CustomCheckbox;
